import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'facturacredito'

const FacturaCreditoRepository = {
  detalle() {
    return ApiService.get(`${REPOSITORY_URL}/detalle`)
  },
}

export default FacturaCreditoRepository
